














import { Component, Vue, Prop } from 'vue-property-decorator'

import Customer from '@/models/customer'
import Passenger from '@/models/passenger'
import User from '@/models/user'

@Component
export default class LargeAvatar extends Vue {
  @Prop() person!: Passenger | Customer | User
  @Prop() title!: 'string'

  showPlaceholder = false

  get avatarUrl(): string | undefined {
    return this.person && this.person.largeAvatarUrl
  }

  get placeholderText(): string {
    return this.person
      ? `${this.person.firstName[0]}${this.person.lastName[0]}`
      : ''
  }

  replaceWithPlaceholder() {
    this.showPlaceholder = true
  }
}
